import type { SvgIconComponent } from '@mui/icons-material';
import type Meta from './meta';
import type { NotificationType } from './notifications';

export enum Role {
  SUPER = 'SUPER_ADMIN',
  PROVIDER = 'PROVIDER_ADMIN',
  PHARMACIST = 'PHARMACIST',
  PHARMACIST_ADMIN = 'PHARMACIST_ADMIN',
  ADT_ADMIN = 'ADT_ADMIN',
  ADMIN = 'ADMIN'
}

export enum Titles {
  SUPER_ADMIN = 'superadmin',
  PHARMACY_DIRECTOR = 'pharmacydirector',
  PHARMACY_MANAGER = 'pharmacymanager',
  CARE_ADMINISTRATOR = 'careadministrator',
  CARE_MANAGER = 'caremanager',
  CARE_OBSERVER = 'careobserver',
  CARE_PROVIDER = 'careprovider',
  CARE_TECHNICIAN = 'caretechnician',
  CARE_COORDINATOR = 'carecoordinator',
  PHARMACIST = 'pharmacist',
  CLINICAL_SUPPORT_STAFF = 'clinicalsupportstaff',
  PHARMACY_INTERN_OR_STUDENT = 'pharmacyinternorstudent',
  PROVIDER_ADMIN = 'provideradmin',
  ADMIN = 'admin'
}

export const ROLE_TYPE_OPTIONS = [
  { label: 'Provider Admin', value: Role.PROVIDER },
  { label: 'Pharmacist', value: Role.PHARMACIST },
  { label: 'Pharmacist Admin', value: Role.PHARMACIST_ADMIN },
  { label: 'ADT Admin', value: Role.ADT_ADMIN },
  { label: 'Admin', value: Role.ADMIN }
];

export const PROVIDER_TITLE_OPTIONS: { label: string; value: string }[] = [
  { label: 'MD', value: 'MD' },
  { label: 'NP', value: 'NP' },
  { label: 'PA', value: 'PA' }
];

export const TITLE_TYPE_OPTIONS: { label: string; value: Titles }[] = [
  { label: 'Admin', value: Titles.ADMIN },
  { label: 'Pharmacy Director', value: Titles.PHARMACY_DIRECTOR },
  { label: 'Pharmacy Manager', value: Titles.PHARMACY_MANAGER },
  { label: 'Care Administrator', value: Titles.CARE_ADMINISTRATOR },
  { label: 'Pharmacist', value: Titles.PHARMACIST },
  { label: 'Clinical Support Staff', value: Titles.CLINICAL_SUPPORT_STAFF },
  { label: 'Pharmacy Intern or Student', value: Titles.PHARMACY_INTERN_OR_STUDENT },
  { label: 'Provider Admin', value: Titles.PROVIDER_ADMIN }
];

export const ROLE_TYPES = [
  { label: 'Pharmacy Director', value: 'pharmacydirector' },
  { label: 'Pharmacy Manager', value: 'pharmacymanager' },
  { label: 'Care Administrator', value: 'careadministrator' },
  { label: 'Care Manager', value: 'caremanager' },
  { label: 'Care Observer', value: 'careobserver' },
  { label: 'Care Provider', value: 'careprovider' },
  { label: 'Care Provider', value: 'care provider' },
  { label: 'Care Technician', value: 'caretechnician' },
  { label: 'Pharmacist', value: 'pharmacist' },
  { label: 'Clinical Support Staff', value: 'clinicalsupportstaff' },
  { label: 'Pharmacy Intern or Student', value: 'pharmacyinternorstudent' },
  // Legacy titles kept for label lookups on accounts created before this list was consolidated.
  { label: 'Pharmacy Technician ', value: 'pharmacytechnician' },
  { label: 'Pharmacy Assistant', value: 'pharmacyassistant' },
  { label: 'Pharmacy Intern', value: 'pharmacyintern' },
  { label: 'Super Admin', value: 'superadmin' },
  { label: 'Provider Admin', value: 'provideradmin' },
  { label: 'Pharmacist Admin', value: 'pharmacistadmin' },
  { label: 'ADT Admin', value: 'adtadmin' },
  { label: 'Care Coordinator', value: 'carecoordinator' },
  { label: 'Admin', value: 'admin' }
];

export const RELYING_PARTY_OPTIONS = [{ label: 'Truentity Health', value: 'Truentity Health' }];

// Key in a relying party admin's `settings` JSON: whether to ask "log any activities?"
// when leaving a patient's page. A missing key means on.
export const ACTIVITY_LOG_REMINDER_SETTINGS_KEY = 'activityLogReminder';

export enum MedicalServices {
  MTM = 'MTM',
  TCM = 'TCM',
  RPM = 'RPM',
  CCM = 'CCM'
}

export type RoleBasedIconType = {
  Icon: SvgIconComponent;
  color: 'primary' | 'secondary' | 'error' | 'info' | 'success';
};

export type RelyingPartyAdminNotificationType = {
  totalReadNotificationCount: number;
  totalUnreadNotificationCount: number;
  notifications: NotificationType[];
  meta: Meta;
};
